import { AbstractControl, ValidatorFn } from '@angular/forms';
import { PersonalCodeValidatorAbstract } from './personal-code.factory';

export class FinlandPersonalCodeValidator implements PersonalCodeValidatorAbstract {
    public getPersonalCodeValidator(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: boolean } | null => {
            // Finland national ID format: DDMMYYCZZZQ
            const personalCodeRegex = /^(\d{6}[-+]\d{2}[0-9A-FHJ-NPR-Y])$/i;
            if (!personalCodeRegex.test(control.value)) {
                return { personalCode: true };
            }

            const day = parseInt(control.value.substr(0, 2), 10);
            const month = parseInt(control.value.substr(2, 2), 10) - 1;
            let year = parseInt(control.value.substr(4, 2), 10);
            const century = control.value.charAt(6).toUpperCase();

            if (century === '-') {
                year += 1800;
            } else if (century === '+') {
                year += 1900;
            } else if (century === 'A') {
                year += 2000;
            }

            const birthDate = new Date(year, month, day);

            if (
                birthDate.getFullYear() % 100 === year % 100 &&
                birthDate.getMonth() === month &&
                birthDate.getDate() === day
            ) {
                return null;
            } else {
                console.log(2);
                return { personalCode: true };
            }
        };
    }
}
